import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/SET_PREV_PAGE_FILTERS";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";

export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";

export const FETCH_LEADS_SUCCESS = "saga/FETCH_LEADS_SUCCESS";
export const FETCH_LEADS_FAILURE = "saga/FETCH_LEADS_FAILURE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  try {
    yield getLeads({ short_url, organization_id, date: payload.date });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  try {
    yield getLeads({ short_url, organization_id, date: payload.date });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getLeads(params) {
  try {
    const res = yield call(axios.get, queryParams.apiVersion + "marketing/profiles", { params });
    yield put({ type: FETCH_LEADS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_LEADS_FAILURE, error });
  }
}
